var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 201.854,
    height: 76.444,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5270.34 1995.92",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id17",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1202.64,
    y1: 1276.71,
    x2: 1202.64,
    y2: 946.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id34",
    gradientUnits: "userSpaceOnUse",
    x1: 3836.97,
    y1: 377.97,
    x2: 3836.97,
    y2: 1338.83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#79bfe9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#fefefe"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 3711.85,
    y1: 1227.23,
    x2: 3711.85,
    y2: 1167.37
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 2484.43,
    y1: 975.43,
    x2: 2484.43,
    y2: 693.29
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 2187.13,
    y1: 1162.36,
    x2: 2187.13,
    y2: 995.69
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id4",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1350.79,
    y1: 1163.45,
    x2: 1350.79,
    y2: 996.78
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id5",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 2700.31,
    y1: 1276.26,
    x2: 2700.31,
    y2: 988.87
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id6",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 3809.81,
    y1: 1682.72,
    x2: 3809.81,
    y2: 21.72
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id7",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 2430.63,
    y1: 1276.26,
    x2: 2430.63,
    y2: 988.87
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id8",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 959.3,
    y1: 973.25,
    x2: 959.3,
    y2: 691.09
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id9",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1999.32,
    y1: 1276.99,
    x2: 1999.32,
    y2: 983.04
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id10",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 2704.08,
    y1: 975.43,
    x2: 2704.08,
    y2: 693.29
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id11",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1206.05,
    y1: 973.25,
    x2: 1206.05,
    y2: 691.09
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id12",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 2956.22,
    y1: 1271.31,
    x2: 2956.22,
    y2: 989.16
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id13",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 3671.4,
    y1: 1226.63,
    x2: 3671.4,
    y2: 1166.77
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id14",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1709.39,
    y1: 1248.05,
    x2: 1709.39,
    y2: 1174.55
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id15",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1521.63,
    y1: 1271.31,
    x2: 1521.63,
    y2: 989.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id16",
    gradientUnits: "userSpaceOnUse",
    x1: 2633.58,
    y1: -733.77,
    x2: 2761.23,
    y2: 1561.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ce9549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#bc6f3b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 3684.44,
    y1: 1228.5,
    x2: 3684.44,
    y2: 1167.91
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id18",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 3810.91,
    y1: 1663.49,
    x2: 3810.91,
    y2: 175.02
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id19",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 2959.5,
    y1: 975.43,
    x2: 2959.5,
    y2: 693.29
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id20",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1935.4,
    y1: 973.25,
    x2: 1935.4,
    y2: 691.09
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id21",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id16",
    x1: 2632.38,
    y1: -811.36,
    x2: 2760.03,
    y2: 1505.7
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id22",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 2742.3,
    y1: 4630.82,
    x2: 2604.67,
    y2: 584.35
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id23",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 2259.16,
    y1: 1015.33,
    x2: 2259.16,
    y2: 688.58
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id24",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id16",
    x1: 2693.22,
    y1: 283.04,
    x2: 2741.08,
    y2: 3172.94
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id25",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1429.34,
    y1: 973.25,
    x2: 1429.34,
    y2: 691.09
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id26",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1814.83,
    y1: 1162.36,
    x2: 1814.83,
    y2: 995.69
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id27",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 974.13,
    y1: 1276.26,
    x2: 974.13,
    y2: 988.87
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id28",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 1685.46,
    y1: 978.92,
    x2: 1685.46,
    y2: 684.96
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id29",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id16",
    x1: 1709.57,
    y1: -1022.92,
    x2: 1836.96,
    y2: 1834.81
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id30",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id16",
    x1: 2608.7,
    y1: -1004.84,
    x2: 2736.39,
    y2: 1779.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id31",
    gradientUnits: "userSpaceOnUse",
    x1: 1643.11,
    y1: 1074.06,
    x2: 1492.28,
    y2: 3268.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#c6722c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    style: {
      stopOpacity: 1,
      stopColor: "#c6722c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#a85823"
    }
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id32",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id16",
    x1: 4155.07,
    y1: -847.66,
    x2: 4279.5,
    y2: 1731
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id33",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id16",
    x1: 964.84,
    y1: -989.34,
    x2: 1092.5,
    y2: 1868.23
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fil40{fill:#006cb5}.fil41{fill:#98a5ad}.fil37{fill:#fefefe}.fil11{fill:#e8b667;fill-rule:nonzero}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1692573812080"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2761.93 1712.42c-203.38 12.68-406.28 24.42-608.76 32.83-576.87 23.93-1142.98 7.07-1717.5-16.9l2326.26-15.93z",
    style: {
      fill: "url(#id31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.45 1086.39c-19.24-7.52-38.9-13.64-58.61-18.75 25.29-1.89 43.13 6.55 58.61 18.75z",
    style: {
      fill: "#924e21",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5191.08 171.9c34.26 69.07 65.46 241.54-10.02 323.42-38.42 41.6-92.54 66.19-148.36 75.8-55.77 9.59-112.84 6.47-169.36 3.28-28.92-1.59-61.96-5.46-78.29-29.39-14.24-20.84-9.4-50.23 4.76-71.11 14.2-20.84 35.91-35.13 57.13-48.88 63.04-40.83 183.27-462.78 344.14-253.12z",
    style: {
      fill: "#773f1e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5061.31 1659.52c-54.13 175.93-233.58 321.62-413 321.62l-1036.24 14.77c-40.14.45-251.93-132.8-261.94-169.41-74-270.76 516.38.17 662.43-22 0 0 224.85-83.43 220.09-84.32-422.45-80.68-848.84 110.14-1268.08 219.79-58.64 15.39-117.73 29.27-176.91 41.17H648.04c-179.95 0-272.41-144.24-326.46-320.18l-170.31-610.39c-10.02-35.91 5.96-75.27 40.13-91.51 21.34-10.13 215.74-93.13 238.07-99.07 97.54-25.32 104.27 69.76 179.83 80.1 9.51 1.31 13.62-11.04 5.62-16.2-147.09-94.92-317.38-80.8-466.2-152.05-24.91-11.94-45.58-30.17-62-49.16-31.77-36.69-50.93-82.07-61.93-128.94C-83.62 131.36 171.26 47.32 639.91 4.11h1270.98c9.86 21.79-46.49 65.95-87.9 74.85-154.51 32.5-308.97 65-463.44 97.14-9.73 2.04-8.45 15.58 1.52 16.12 526.07 26.75 958.39-99.04 1445.72-144.92 106.16-10.01 34.03-11.48 51.18-11.48l2050.24 28.43c247.57 0 221.85 374.35 138.33 399.47-6.28 1.88 145.93 91.87 152.34 93.61 219.8 58.83-137.56 1102.18-137.56 1102.18z",
    style: {
      fill: "url(#id22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5214.26 589.09c-6.07 22.53-16.37 60.53-29.55 108.84-24.34 89.58-58.1 213.89-91.84 339.09-15.88 56.3-31.35 112.56-45.93 166.03-11.2 42.68-22.48 83.02-32.78 120.53-8.91 31.93-16.86 61.48-23.92 87.7-20.12 73.21-32.79 119.63-32.79 119.63-12.15 39.89-26.22 77.39-43.09 112.06-25.32 52.57-56.7 97.13-96.56 128.99-41.72 34.25-92.78 54.45-156.07 54.45H3350.04c-15.46 0-21.54-19.75-8.86-28.64 193.49-130.87 426.43-204.01 660.75-204.95 4.22 0 5.12-6.55.49-7.51-382.39-74.56-768.11 101.77-1147.71 203.1a2513.33 2513.33 0 0 1-160.24 38H757.15c-122.78 0-200.59-76-252.12-183.44-5.18-9.81-9.86-20.14-14.04-30.45-10.8-25.82-20.6-53.47-29.06-81.61l-44.97-164.17-21.14-78.33-88.06-321.73c-3.77-13.13-3.77-26.75-.49-38.95 5.18-19.24 17.85-36.11 36.56-45.5 19.2-9.36 39.4-16.87 60-22.49 88.07-23.44 250.21-4.68 318.66 5.13 8.42.94 12.2-10.31 4.68-14.98-2.34-1.4-4.68-3.29-7.47-4.22-81.09-51.59-170.14-66.61-256.85-86.31-53.43-12.19-106.85-25.32-157.46-50.19-18.72-8.9-34.68-22.04-47.76-36.56-3.3-2.83-6.09-6.12-8.46-8.9-23.88-28.66-40.26-62.39-50.6-98.54-2.34-7.02-4.22-13.58-5.62-20.63-19.2-84.42-25.28-156.15-19.71-218.08 2.83-32.38 8.91-61.88 18.76-88.65C254.83 57.25 459.6.01 750.16.01h1150.45c2.79 6.56-.5 14.57-7.03 23.48-7.05 8.9-17.81 18.27-29.99 26.27h-.45c-13.59 8.89-28.61 16.41-42.19 19.2-125.61 26.75-251.16 53.96-376.77 81.16-1.39 0-2.79.45-4.23.91-12.63 2.39-25.77 5.18-38.41 8-2.83.45-4.68 2.34-5.16 4.68-1.88 4.23.89 9.4 6.55 9.86 476.13 24.87 874.94-79.24 1308.9-168.83 14.98-3.34 30.9-4.73 46.37-4.73h1910.6c223.08 0 396.01 33.77 492.52 131.81 33.29 33.29 50.15 75.51 51.55 118.65.91 13.16 0 26.26-2.38 38.94-5.59 30.49-19.17 60.04-41.2 85.36-3.33 4.22-7.03 8.45-11.25 12.19-11.74 11.73-24.83 23.02-38.42 32.82-63.28 46.46-138.29 74.13-213.68 97.1-5.66 1.88-4.27 9.85 1.81 9.85 98.45-5.62 203.87-3.28 291.03 30.49 7.02 2.82 12.2 8.46 14.99 15.02 1.88 5.17 1.88 11.25.48 16.86z",
    style: {
      fill: "url(#id24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5214.26 589.09c-6.07 22.53-16.37 60.53-29.55 108.84-148.06-9.4-296.62-14.08-445.18-15.02-574.53-3.73-1144.38 49.24-1715.18 91.47-921.78 68-1874.52 105.99-2766.75-101.77-3.3-2.83-6.09-6.12-8.46-8.9-23.88-28.66-40.26-62.39-50.6-98.54 1011.78 231.25 2073.19 164.65 3115.88 83.02 573.62-44.53 1150.97-97.54 1728.79-82.06 54.83 1.38 111.54 3.28 170.56 6.11 1.88 5.17 1.88 11.25.48 16.86z",
    style: {
      fill: "url(#id16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5210.49 289.4c-5.59 30.49-19.17 60.04-41.2 85.36-136.37-7.96-272.74-11.73-409.12-12.64-574.53-3.33-1144.41 49.24-1715.16 91.43-957.41 70.83-1949.5 108.84-2871.79-127.09 2.83-32.38 8.91-61.88 18.76-88.65 1003.78 234.98 2065.71 173.55 3143.07 89.58 574.05-44.56 1150.94-97.59 1728.76-82.06 48.3 1.39 97.95 2.79 149.05 5.13.91 13.16 0 26.26-2.38 38.94z",
    style: {
      fill: "url(#id21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5092.87 1037.02c-15.88 56.3-31.35 112.56-45.93 166.03-170.54-33.28-340.68-67.55-509.4-105.99-299.9-68-534.67-59.54-834.13-1.88-215.56 41.72-435.37 66.6-657.95 73.2-500.95 15.43-1000.51-50.23-1493.53-115.88-416.58-55.81-827.61-98.01-1244.68-124.76 5.18-19.24 17.85-36.11 36.56-45.5 19.2-9.36 39.4-16.87 60-22.49 88.07-23.44 250.21-4.68 318.66 5.13 8.42.94 12.2-10.31 4.68-14.98-2.34-1.4-4.68-3.29-7.47-4.22 774.64 58.64 1547.86 246.21 2327.18 214.33 506.12-20.63 946.61-190.42 1457.01-119.58 197.72 27.66 393.58 61.43 589.01 96.61z",
    style: {
      fill: "url(#id30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4018.35 1298.76c-37.47.95-321.04 13.13-321.5 23.93-3.28 46.41 118.57 43.58 147.61 47.36 379.16 51.13 713.24 194.15 1069.89 272.94-25.32 52.57-56.7 97.13-96.56 128.99-181.34-58.15-357.06-135.51-527.21-191.82-100.25-32.82-202.44-62.87-308.31-79.24-105.02-15.97-211.84 0-314.03-15.97-89.04-14.07-179.91-39.38-195.38-121.96-43.12-235.43 574.53-163.69 717.47-157.08 280.7 13.57 558.16 49.24 823.83 117.69-8.91 31.93-16.86 61.48-23.92 87.7-192.1-47.36-387.02-83.47-589.02-101.28a3068.381 3068.381 0 0 0-382.88-11.25z",
    style: {
      fill: "url(#id32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3241.33 1446.04c-78.26 240.11-379.56 223.69-628.86 235.44-191.2 9.36-349.64 63.31-485.06 144.94h-222.59c50.6-39.43 104.97-76 164.47-108.33 135.02-74.16 285.87-124.8 449.89-138.88 184.63-15.93 473.34 46.9 583.93-104.11-916.17-40.34-1811.73-63.82-2686.16-108.35l-21.14-78.33c930.74 22.54 1861.44 70.83 2791.68 99.44 37.47.94 63.25 29.09 53.84 58.18z",
    style: {
      fill: "url(#id29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.26 1672.57c-.94 68.95-35.61 117.7-90.49 153.86h-363.62c135.46-24.87 255.41-56.31 305.52-106.49-348.17-6.12-679.47-30.5-1020.64-76.95-5.18-9.81-9.86-20.14-14.04-30.45 372.08 7.47 749.8 11.7 1121.85 9.36 33.77-.45 61.88 23.92 61.43 50.67z",
    style: {
      fill: "url(#id33)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M1900.67.12c2.79 6.57-.49 14.53-7.06 23.48-281.16 37.51-567.02 64.22-848.21 86.75-170.1 13.59-354.28 13.59-518.31 65.65-277.86 88.2-290.54 378.04-80.1 545.49 13.13 10.29 17.81 24.41 15.93 37.99-53.44-12.18-106.86-25.36-157.47-50.18-22.48-10.8-41.24-27.67-56.22-45.51-28.56-33.78-45.93-75.51-56.22-119.13C95.05 117.37 334.99.12 750.17.12h1150.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M5210.57 289.51C5017.07 82.64 4653.85 88.75 4385.35 71.9c-329.45-20.19-660.8-18.76-990.25-.95-660.29 36.12-1363.23 216.68-1986.47 146.79-30.94-3.73-37.02-43.12-12.19-53.92-1.88 4.22.91 9.4 6.52 9.84 476.16 24.88 874.92-79.27 1308.89-168.86 14.98-3.3 30.95-4.69 46.41-4.69h1910.55c223.08 0 396.01 33.78 492.54 131.82 43.13 43.12 59.09 102.22 49.2 157.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2103333174496"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1101.02 1239.86v-140.85c0-78.61-28.38-93.9-93.89-93.9H852.08v63.33h31.67v97.16c0 19.66-18.56 27.31-38.21 15.29v53.51s13.1 9.82 46.94 9.82c58.95 0 77.52-27.3 77.52-96.08v-79.7h17.48c19.66 0 26.2 4.36 26.2 31.66v139.75h87.34z",
    style: {
      fill: "url(#id27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#id17)"
    },
    d: "M1295.36 1052.06v-46.95h-103.71v-40.39h-82.99v103.72h96.08l-63.33 171.42h93.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#id4)"
    },
    d: "M1394.72 1144.86V1006.2h-88.43v138.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.38 1239.86c-18.56-34.94-40.39-72.06-55.68-99.35 21.83-10.92 49.13-31.67 49.13-78.62v-56.77h-82.98v50.23c0 13.11 0 32.75-3.28 41.49-21.84-34.94-37.12-58.96-56.77-91.72-9.83 1.1-89.53 0-89.53 0 20.74 30.57 41.5 58.96 57.87 80.79-25.1 18.56-46.95 43.68-46.95 87.35v66.6h81.89v-66.6c0-30.57 1.1-39.31 4.37-44.77 24.02 41.49 54.59 105.92 56.77 111.37h85.16z",
    style: {
      fill: "url(#id15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#id14)"
    },
    d: "M1743.01 1239.86v-61.15h-67.69v61.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#id26)"
    },
    d: "M1858.73 1143.78v-138.67h-88.43v138.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2121.87 1118.66c0-58.95-15.29-119.01-79.7-119.01-49.13 0-64.43 60.06-64.43 60.06s-5.46-34.94-12-54.6h-90.62s19.65 57.87 21.83 88.44c1.1 25.11-13.1 146.31-13.1 146.31h88.43l7.65-121.19c1.1-25.11 13.11-56.78 29.49-56.78 19.65 0 25.1 25.11 25.1 55.69 0 54.59-10.91 68.78-24.02 68.78-8.73 0-15.29-6.55-15.29-6.55v54.6s12.01 9.82 46.95 9.82c58.95 0 79.7-64.42 79.7-125.55z",
    style: {
      fill: "url(#id9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#id3)"
    },
    d: "M2231.05 1143.78v-138.67h-88.43v138.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2557.49 1239.86v-140.85c0-78.61-28.39-93.9-93.9-93.9h-155.03v63.33h31.66v97.16c0 19.66-18.56 27.31-38.21 15.29v53.51s13.1 9.82 46.94 9.82c58.96 0 76.43-27.3 76.43-96.08v-79.7h17.48c20.73 0 26.2 4.36 26.2 31.66v139.75h88.43z",
    style: {
      fill: "url(#id7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2827.19 1239.86v-140.85c0-78.61-28.39-93.9-92.81-93.9h-156.14v63.33H2611v97.16c0 19.66-19.66 27.31-39.32 15.29v53.51s13.11 9.82 48.05 9.82c57.87 0 76.42-27.3 76.42-96.08v-79.7h17.48c19.65 0 26.2 4.36 26.2 31.66v139.75h87.35z",
    style: {
      fill: "url(#id5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3066.29 1239.86v-140.85c0-77.52-37.12-93.9-92.8-93.9h-127.74v63.33h104.82c21.83-1.1 28.38 9.82 28.38 37.11v134.3h87.34zm-133.2 0v-115.73l-88.43 2.19v113.54h88.43z",
    style: {
      fill: "url(#id12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.63 941.79V802.04c0-77.52-38.22-94.98-96.09-94.98H845.53v63.32h108.09c21.84 0 28.39 9.82 28.39 37.12v134.29h90.62zm-137.57 0V826.07l-90.62 2.17v113.55h90.62z",
    style: {
      fill: "url(#id8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.29 824.96c0-76.43-28.38-117.92-97.16-117.92H1092.3v81.89c0 52.41 14.19 62.23 81.88 62.23 7.65 0 19.65-2.18 19.65-2.18v-41.49S1172 815.13 1172 793.3v-28.39h25.11c24.02 0 31.66 16.37 31.66 57.86 0 38.21-2.19 65.52-31.66 62.24H1092.3v56.77h128.83c68.78 0 97.16-31.66 97.16-116.82z",
    style: {
      fill: "url(#id11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.2 760.55v-53.5h-85.15v68.78c0 12.01-1.1 19.65-2.19 21.84-1.1 2.18-2.18 0-2.18 0-24.02-41.5-49.13-90.62-49.13-90.62h-90.62c16.38 31.66 50.22 81.89 50.22 81.89l52.41 78.61 14.19 22.92-18.56-3.28h-86.25v54.59h208.55v-41.49l-50.23-62.24s58.95-7.64 58.95-77.52z",
    style: {
      fill: "url(#id25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811.78 821.69c0-58.96-16.37-120.11-82.97-120.11-50.23 0-65.51 60.05-65.51 60.05s-5.46-34.93-12.01-54.58h-93.9s20.74 57.87 21.83 88.43c1.1 25.11-12 146.31-12 146.31h90.62l6.54-121.19c2.19-25.11 14.19-55.68 31.67-55.68 19.66 0 25.1 24.02 25.1 54.58 0 54.6-10.91 68.79-25.1 68.79-8.73 0-15.29-5.46-15.29-5.46v53.5s13.1 9.83 49.13 9.83c60.05 0 81.88-63.32 81.88-124.47z",
    style: {
      fill: "url(#id28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2048.72 941.79V802.04c0-78.61-38.21-94.98-96.08-94.98h-131.02v63.32h108.09c21.85 0 28.39 9.82 28.39 37.12v134.29h90.62zm-137.57 0V828.24h-90.62v113.55h90.62z",
    style: {
      fill: "url(#id20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2378.44 758.36v-51.31h-240.19v63.32h149.57l-39.31 171.41h92.81l37.11-183.42zm-149.57 220.55V828.23h-90.62v150.68h90.62z",
    style: {
      fill: "url(#id23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2574.98 803.13c0-77.52-39.31-93.9-96.09-93.9h-86.25v63.32h65.51c19.66 0 26.21 3.28 26.21 31.66v139.75h90.62V803.12z",
    style: {
      fill: "url(#id2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2826.09 943.97c-18.56-36.02-40.4-73.15-56.77-99.35 22.92-10.91 50.22-32.75 50.22-78.61v-56.77h-85.16v50.23c0 13.1 0 32.75-2.18 41.49-24.02-34.94-39.31-58.96-60.06-91.72h-91.71c21.84 30.57 42.58 57.87 60.05 80.79-26.2 17.48-49.13 43.68-49.13 86.26v67.69h85.16v-67.69c0-30.57 1.1-38.22 3.28-43.68 26.2 40.4 56.78 104.81 58.95 111.36h87.35z",
    style: {
      fill: "url(#id10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3071.75 826.06c0-76.43-29.48-116.83-98.26-116.83h-127.74v80.79c0 53.5 14.2 63.32 80.8 63.32 8.73 0 19.65-2.18 19.65-2.18v-42.58s-20.74 7.65-20.74-14.2V766h25.11c22.92 0 31.66 17.48 31.66 58.96 0 38.21-2.19 64.41-31.66 61.13h-104.82v57.87h128.84c68.78 0 97.16-31.66 97.16-117.91z",
    style: {
      fill: "url(#id19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3187.53 878.34c0-342.21 276.97-619.19 619.19-619.19 341.62 0 619.19 276.98 619.19 619.19 0 342.22-277.57 619.19-619.19 619.19-342.22 0-619.19-276.97-619.19-619.19z",
    style: {
      fill: "url(#id18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3202.38 1013.78c4.54-1.22 9.51-1.99 15.38-1.99 21.35 0 29.65 16.02 51.01 16.02 21.34 0 29.64-16.02 51.01-16.02 19.93 0 28.49 13.96 46.93 15.81 1.16.11 2.26.18 3.33.19l.74.02c21.35 0 29.65-16.02 51.01-16.02 21.35 0 29.65 16.02 51.01 16.02 21.34 0 29.65-16.02 51-16.02 20.76 0 29.65 16.02 51.02 16.02 20.75 0 29.64-16.02 51-16.02 20.75 0 29.65 16.02 51 16.02l.77-.01.2-.01h.1c.91-.02 1.79-.08 2.64-.16l.06-.01.66-.07.23-.03h.05l.79-.11.08-.01.72-.11.12-.03.1-.02c.42-.06.85-.15 1.26-.24l.08-.01.27-.06.09-.02.6-.14.15-.03.21-.05c.44-.11.87-.23 1.3-.35l.13-.03.04-.02.75-.22.34-.11.45-.15.16-.05.02-.01c.79-.26 1.56-.54 2.33-.84l.09-.03.47-.19.12-.05.05-.03 1.12-.46.2-.09.15-.07.59-.26.23-.11.5-.24.64-.3.08-.04.48-.24.24-.11.34-.17c.69-.35 1.39-.71 2.07-1.07l.54-.29.59-.31.14-.07.56-.3.55-.3.15-.08.4-.22.05-.02.96-.51.11-.06.55-.3.04-.02 1.08-.57.33-.17.24-.12a78.9 78.9 0 0 1 2.25-1.14l.38-.19.19-.09.22-.11.71-.35.22-.1.12-.05.46-.22.27-.12.33-.14.42-.18.17-.07.58-.26v-.01l.6-.24.16-.07.44-.17.13-.05.46-.18 1.18-.42.07-.02.03-.02.18-.05 1.06-.35 3.75-72.4-65.24-15.42h-123.96l-47.44-99.05v-16.01l238.43-83.04 1.18-1.78 14.23-45.67 24.91-371.87h-42.7l-11.27-42.11 2.97-7.11h54.56l2.96-47.45h21.35l7.71-96.09 5.93.59 1.78 95.49h27.89l2.96 47.45h60.49l2.38 7.11-9.49 42.11h-49.81l24.91 371.87 14.23 45.67 1.19 1.78 238.43 83.04v16.01l-47.45 99.05h-126.93l-62.28 15.42 4.38 84.53.37-.12.14-.06.11-.03 1.19-.43.25-.09.35-.14.41-.16.17-.08.57-.24.58-.25.37-.16.53-.24.24-.11 1.12-.53.09-.04.47-.23.96-.47.15-.08.54-.28.02-.01.19-.1.69-.36c1.33-.7 2.66-1.42 3.99-2.13l.02-.01.7-.37.36-.2.34-.18.21-.11.48-.26.05-.04.54-.29.12-.05.43-.23.27-.14.28-.14.09-.05.86-.42.17-.08.03-.02.51-.26 1.12-.53.52-.24.04-.02.57-.25.13-.05.63-.28.11-.05.29-.12.46-.2.59-.23.12-.04.05-.03.09-.03c.48-.18.97-.36 1.45-.53l.79-.26.03-.01.61-.19.15-.05.8-.23.04-.01c1.02-.29 2.06-.53 3.15-.75l.19-.04.22-.03.66-.12h.01l.84-.13.04-.01.51-.07.16-.03.48-.05.16-.01.88-.1c.47-.03.95-.07 1.42-.09l.25-.01.66-.03.17-.01h.23l.77-.01c21.35 0 29.66 16.02 51.01 16.02 20.76 0 29.65-16.02 51.01-16.02 20.75 0 29.65 16.02 51.01 16.02 20.75 0 29.65-16.02 51-16.02 20.76 0 29.65 16.02 51.01 16.02 20.76 0 29.65-16.02 51.01-16.02 6.92 0 12.51 1.78 17.69 4.14 9.16 3.35 18.68 7.94 24.62 10.92 2.67.59 5.56.95 8.68.95 20.76 0 29.66-16.02 50.43-16.02 21.34 0 30.25 16.02 51 16.02 10.83 0 18.74-2.44 26.49-5.69-64.87 272.79-310.18 475.42-602.39 475.42-295.68 0-542.63-206.78-604.33-483.75z",
    style: {
      fill: "url(#id6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3688.69 1221.75c-11.87-14.82-10.09-34.4-2.37-50.41-1.18 16.6 1.18 33.8 2.37 50.41z",
    style: {
      fill: "url(#id0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3675.63 1219.97c-11.86-14.24-10.08-33.81-2.37-49.82-1.18 16.02 1.18 33.22 2.37 49.82z",
    style: {
      fill: "url(#id13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3715.98 1220.57c-11.27-14.24-10.09-33.81-2.38-49.82-.59 16.02 1.18 33.81 2.38 49.82z",
    style: {
      fill: "url(#id1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2103333174496_0"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M1136.2 1218.52v-140.85c0-78.61-28.38-93.9-93.89-93.9H887.26v63.33h31.67v97.16c0 19.66-18.56 27.31-38.21 15.29v53.51s13.1 9.82 46.94 9.82c58.95 0 77.52-27.3 77.52-96.08v-79.7h17.48c19.66 0 26.2 4.36 26.2 31.66v139.75h87.34zM1330.54 1030.73v-46.96h-103.71v-40.39h-82.99v103.73h96.08l-63.33 171.41h93.91zM1429.9 1123.53V984.87h-88.43v138.66zM1675.56 1218.52c-18.56-34.94-40.39-72.06-55.68-99.35 21.83-10.92 49.13-31.67 49.13-78.62v-56.77h-82.98v50.23c0 13.11 0 32.75-3.28 41.49-21.84-34.94-37.12-58.96-56.77-91.72-9.83 1.1-89.53 0-89.53 0 20.74 30.57 41.5 58.96 57.87 80.79-25.1 18.56-46.95 43.68-46.95 87.35v66.6h81.89v-66.6c0-30.57 1.1-39.31 4.37-44.77 24.02 41.49 54.59 105.92 56.77 111.37h85.16zM1778.19 1218.52v-61.14h-67.69v61.14zM1893.91 1122.44V983.77h-88.43v138.67zM2157.05 1097.33c0-58.95-15.29-119.01-79.7-119.01-49.13 0-64.43 60.06-64.43 60.06s-5.46-34.94-12-54.6h-90.62s19.65 57.87 21.83 88.44c1.1 25.11-13.1 146.31-13.1 146.31h88.43l7.65-121.19c1.1-25.11 13.11-56.78 29.49-56.78 19.65 0 25.1 25.11 25.1 55.69 0 54.59-10.91 68.78-24.02 68.78-8.73 0-15.29-6.55-15.29-6.55v54.6s12.01 9.82 46.95 9.82c58.95 0 79.7-64.42 79.7-125.55zM2266.23 1122.44V983.77h-88.43v138.67zM2592.67 1218.52v-140.85c0-78.61-28.39-93.9-93.9-93.9h-155.03v63.33h31.66v97.16c0 19.66-18.56 27.31-38.21 15.29v53.51s13.1 9.82 46.94 9.82c58.96 0 76.43-27.3 76.43-96.08v-79.7h17.48c20.73 0 26.2 4.36 26.2 31.66v139.75h88.43zM2862.37 1218.52v-140.85c0-78.61-28.39-93.9-92.81-93.9h-156.14v63.33h32.76v97.16c0 19.66-19.66 27.31-39.32 15.29v53.51s13.11 9.82 48.05 9.82c57.87 0 76.42-27.3 76.42-96.08v-79.7h17.48c19.65 0 26.2 4.36 26.2 31.66v139.75h87.35zM3101.47 1218.52v-140.85c0-77.52-37.12-93.9-92.8-93.9h-127.74v63.33h104.82c21.83-1.1 28.38 9.82 28.38 37.11v134.3h87.34zm-133.2 0v-115.73l-88.43 2.19v113.54h88.43zM1107.81 920.45V780.7c0-77.52-38.22-94.98-96.09-94.98H880.71v63.32H988.8c21.84 0 28.39 9.82 28.39 37.12v134.29h90.62zm-137.57 0V804.73l-90.62 2.17v113.55h90.62zM1353.47 803.63c0-76.43-28.38-117.92-97.16-117.92h-128.83v81.89c0 52.41 14.19 62.23 81.88 62.23 7.65 0 19.65-2.18 19.65-2.18v-41.49s-21.83 7.64-21.83-14.19v-28.39h25.11c24.02 0 31.66 16.37 31.66 57.86 0 38.21-2.19 65.52-31.66 62.24h-104.81v56.77h128.83c68.78 0 97.16-31.66 97.16-116.82z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M1578.39 739.21v-53.5h-85.15v68.78c0 12.01-1.1 19.65-2.19 21.84-1.1 2.18-2.18 0-2.18 0-24.02-41.5-49.13-90.62-49.13-90.62h-90.62c16.38 31.66 50.22 81.89 50.22 81.89l52.41 78.61 14.19 22.92-18.56-3.28h-86.25v54.59h208.55v-41.49l-50.23-62.24s58.95-7.64 58.95-77.52zM1846.96 800.35c0-58.96-16.37-120.11-82.97-120.11-50.23 0-65.51 60.05-65.51 60.05s-5.46-34.93-12.01-54.58h-93.9s20.74 57.87 21.83 88.43c1.1 25.11-12 146.31-12 146.31h90.62l6.54-121.19c2.19-25.11 14.19-55.68 31.67-55.68 19.66 0 25.1 24.02 25.1 54.58 0 54.6-10.91 68.79-25.1 68.79-8.73 0-15.29-5.46-15.29-5.46v53.5s13.1 9.83 49.13 9.83c60.05 0 81.88-63.32 81.88-124.47zM2083.9 920.45V780.7c0-78.61-38.21-94.98-96.08-94.98H1856.8v63.32h108.09c21.85 0 28.39 9.82 28.39 37.12v134.29h90.62zm-137.57 0V806.9h-90.62v113.55h90.62zM2413.62 737.03v-51.31h-240.19v63.32H2323l-39.31 171.41h92.81l37.11-183.42zm-149.57 220.55V806.9h-90.62v150.68h90.62zM2610.16 781.79c0-77.52-39.31-93.9-96.09-93.9h-86.25v63.32h65.51c19.66 0 26.21 3.28 26.21 31.66v139.75h90.62V781.78zM2861.27 922.63c-18.56-36.02-40.4-73.15-56.77-99.35 22.92-10.91 50.22-32.75 50.22-78.61V687.9h-85.16v50.23c0 13.1 0 32.75-2.18 41.49-24.02-34.94-39.31-58.96-60.06-91.72h-91.71c21.84 30.57 42.58 57.87 60.05 80.79-26.2 17.48-49.13 43.68-49.13 86.26v67.69h85.16v-67.69c0-30.57 1.1-38.22 3.28-43.68 26.2 40.4 56.78 104.81 58.95 111.36h87.35zM3106.93 804.73c0-76.43-29.48-116.83-98.26-116.83h-127.74v80.79c0 53.5 14.2 63.32 80.8 63.32 8.73 0 19.65-2.18 19.65-2.18v-42.58s-20.74 7.65-20.74-14.2v-28.38h25.11c22.92 0 31.66 17.48 31.66 58.96 0 38.21-2.19 64.41-31.66 61.13h-104.82v57.87h128.84c68.78 0 97.16-31.66 97.16-117.91z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3222.71 857.01c0-342.21 276.97-619.19 619.19-619.19 341.62 0 619.19 276.98 619.19 619.19 0 342.22-277.57 619.19-619.19 619.19-342.22 0-619.19-276.97-619.19-619.19z",
    style: {
      fill: "#ffd525"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3837.51,
    cy: 858.72,
    r: 480.22,
    style: {
      fill: "url(#id34)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil40",
    d: "M3237.56 992.45c4.54-1.22 9.51-1.99 15.38-1.99 21.35 0 29.65 16.02 51.01 16.02 21.34 0 29.64-16.02 51.01-16.02 19.93 0 28.49 13.96 46.93 15.81 1.16.11 2.26.18 3.33.19l.74.02c21.35 0 29.65-16.02 51.01-16.02 21.35 0 29.65 16.02 51.01 16.02 21.34 0 29.65-16.02 51-16.02 20.76 0 29.65 16.02 51.02 16.02 20.75 0 29.64-16.02 51-16.02 20.75 0 29.65 16.02 51 16.02l.77-.01.2-.01h.1c.91-.02 1.79-.08 2.64-.16l.06-.01.66-.07.23-.03h.05l.79-.11.08-.01.72-.11.12-.03.1-.02c.42-.06.85-.15 1.26-.24l.08-.01.27-.06.09-.02.6-.14.15-.03.21-.05c.44-.11.87-.23 1.3-.35l.13-.03.04-.02.75-.22.34-.11.45-.15.16-.05.02-.01c.79-.26 1.56-.54 2.33-.84l.09-.03.47-.19.12-.05.05-.03 1.12-.46.2-.09.15-.07.59-.26.23-.11.5-.24.64-.3.08-.04.48-.24.24-.11.34-.17c.69-.35 1.39-.71 2.07-1.07l.54-.29.59-.31.14-.07.56-.3.55-.3.15-.08.4-.22.05-.02.96-.51.11-.06.55-.3.04-.02 1.08-.57.33-.17.24-.12a78.9 78.9 0 0 1 2.25-1.14l.38-.19.19-.09.22-.11.71-.35.22-.1.12-.05.46-.22.27-.12.33-.14.42-.18.17-.07.58-.26v-.01l.6-.24.16-.07.44-.17.13-.05.46-.18 1.18-.42.07-.02.03-.02.18-.05 1.06-.35 3.75-72.4-65.24-15.42h-123.96l-47.44-99.05V789.3l238.43-83.04 1.18-1.78 14.23-45.67 24.91-371.87h-42.7l-11.27-42.11 2.97-7.11h54.56l2.96-47.45h21.35l7.71-96.09 5.93.59 1.78 95.49h27.89l2.96 47.45h60.49l2.38 7.11-9.49 42.11h-49.81l24.91 371.87 14.23 45.67 1.19 1.78 238.43 83.04v16.01l-47.45 99.05h-126.93l-62.28 15.42 4.38 84.53.37-.12.14-.06.11-.03 1.19-.43.25-.09.35-.14.41-.16.17-.08.57-.24.58-.25.37-.16.53-.24.24-.11 1.12-.53.09-.04.47-.23.96-.47.15-.08.54-.28.02-.01.19-.1.69-.36c1.33-.7 2.66-1.42 3.99-2.13l.02-.01.7-.37.36-.2.34-.18.21-.11.48-.26.05-.04.54-.29.12-.05.43-.23.27-.14.28-.14.09-.05.86-.42.17-.08.03-.02.51-.26 1.12-.53.52-.24.04-.02.57-.25.13-.05.63-.28.11-.05.29-.12.46-.2.59-.23.12-.04.05-.03.09-.03c.48-.18.97-.36 1.45-.53l.79-.26.03-.01.61-.19.15-.05.8-.23.04-.01c1.02-.29 2.06-.53 3.15-.75l.19-.04.22-.03.66-.12h.01l.84-.13.04-.01.51-.07.16-.03.48-.05.16-.01.88-.1c.47-.03.95-.07 1.42-.09l.25-.01.66-.03.17-.01h.23l.77-.01c21.35 0 29.66 16.02 51.01 16.02 20.76 0 29.65-16.02 51.01-16.02 20.75 0 29.65 16.02 51.01 16.02 20.75 0 29.65-16.02 51-16.02 20.76 0 29.65 16.02 51.01 16.02 20.76 0 29.65-16.02 51.01-16.02 6.92 0 12.51 1.78 17.69 4.14 9.16 3.35 18.68 7.94 24.62 10.92 2.67.59 5.56.95 8.68.95 20.76 0 29.66-16.02 50.43-16.02 21.34 0 30.25 16.02 51 16.02 10.83 0 18.74-2.44 26.49-5.69-64.87 272.79-310.18 475.42-602.39 475.42-295.68 0-542.63-206.78-604.33-483.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M4161.91 1040.26s-63.46 60.5-19.58 121.59c25.51 39.14 71.77 180.3-107.94 241.39-84.22 30.25-90.15 35.58-161.33 86-18.38 8.9-37.36 13.06-33.21 0 1.78-5.92 36.77-41.52 35.58-80.66-.6-28.46-24.92-63.46-34.99-99.05-2.38-8.89-15.42 3.56-15.42-9.48-4.75-13.65-1.78-33.81-7.71-48.04-10.68-41.53 10.68-22.54 19.57-7.12 9.49 15.42 92.52 161.33 155.4 128.71 16.6-7.12 21.34-2.38 11.27-37.37-4.15-19.58 45.08-13.65 59.9-8.31 0 0 71.76-30.84-42.11-114.47-20.17-12.45-61.69-18.98-77.69-18.38-1.19 8.31-1.19 8.9-1.79 18.99 1.19 16.61 5.34 58.12 34.99 91.33 7.71 11.86-.59 11.86-16.61 2.38-16.01-8.9-78.89-40.92-116.25-117.43-4.14-2.97-110.91-4.15-170.81-35.58-5.93-4.15 6.52-2.97 2.38-8.31 0 0-52.8-13.64-92.52-43.88-7.12-5.35-10.09-9.49 1.18-15.42 10.08-5.93 231.9-75.92 418.72-16.61 6.52-1.78 29.66-7.71 75.93-31.43 32.02-16.61 52.18-30.25 90.75-28.47 13.05 10.09-7.72 29.65-7.72 29.65z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M3589.15 1162.38c43.13-12.79 76.61-.51 76.61-.51s-18.38-1.79-42.11 4.14c-6.57 1.7-11.48 3.7-15.06 5.57.64-.73.78-1.72-.37-3.19 0 0-7.56-1.95-19.08-6.01z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M3598.14 1132.21c0-6.52 5.34-12.45 12.45-12.45 6.52 0 11.86 5.93 11.86 12.45s-5.34 11.86-11.86 11.86c-7.11 0-12.45-5.34-12.45-11.86z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M3597.55 1135.77c-.59-3.55 2.97-7.11 7.72-7.71 4.74-.59 8.89 1.78 9.48 5.34.59 4.15-2.96 7.71-7.71 8.3-4.75.59-8.9-2.37-9.49-5.93z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "m3878.05 707.54-180.27 77.11-.16 15.63 89.92.31 1.4 49.23-91.79-.35-.55 55.58 409.73-1.63 25.09-52.36-50.54-.19 7.1-49.26 65.3.23V789.4l-235.01-81.86-3.41-1.18-.67-1.02-14.79-47.2-22.33-333.33c-7.58-4.18-17.74-4.07-31.59 1.37-20.4 7.51-39.5 17.42-54.31 45.56l-19.23 287.17-2.76 8.85 58.51-.24.07 1.47h-.07l1.78 38.55h48.61zm38.62 213.12-24.95.39-4.15 90.75 32.61 3.56 1.25-2.65-4.77-92.05zm-120.98-120.04 150.26.51-1.78 49.24-148.14-.53-.35-49.22zm157.84.53 126.96.43-6.21 49.26-123.2-.44 2.45-49.25zm-183.91-563.34 9.41 8.3 125.15.6-2.18 40.32h22.34l9.49-42.11-2.38-7.11h-60.49l-.06-.95-1.87-29.79-21.21 1.67v28.2l-47.41.17-.04.7h-30.77z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3237.56 992.45c4.54-1.22 9.51-1.99 15.38-1.99 21.35 0 29.65 16.02 51.01 16.02 21.34 0 29.64-16.02 51.01-16.02 21.34 0 29.65 16.02 51 16.02s29.65-16.02 51.01-16.02c21.35 0 29.65 16.02 51.01 16.02 21.34 0 29.65-16.02 51-16.02 20.76 0 29.65 16.02 51.02 16.02 20.75 0 29.64-16.02 51-16.02 20.75 0 29.65 16.02 51 16.02 20.77 0 29.66-16.02 51.02-16.02 20.75 0 29.65 16.02 51 16.02 19.57-5.93 21.95-16.02 43.3-16.02 21.35 0 29.65 16.02 51.01 16.02 21.34 0 29.64-16.02 51-16.02 21.35 0 29.66 16.02 51.01 16.02 20.76 0 29.65-16.02 51.01-16.02 20.75 0 29.65 16.02 51.01 16.02 20.75 0 29.65-16.02 51-16.02 20.76 0 29.65 16.02 51.01 16.02 20.76 0 29.65-16.02 51.01-16.02 20.75 0 29.65 16.02 51 16.02 20.76 0 29.66-16.02 50.43-16.02 21.34 0 30.25 16.02 51 16.02 10.83 0 18.74-2.44 26.49-5.69",
    style: {
      fill: "none",
      stroke: "#fefefe",
      strokeWidth: 24.51,
      strokeMiterlimit: 22.9256
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "fil37",
    d: "M3510.78 1113.4c5.41 4.12 11.95 4.89 40.49 8.13 32.02 3.56 49.82 10.09 49.82 10.09s7.71 1.78 13.05 1.78c5.34 0 27.88 5.93 51.01 9.49 22.53 3.55 33.21 5.33 49.81 5.33 15.42 0 21.35-1.18 21.35-2.96.59-2.37-10.08-9.49-5.34-14.23 4.15-4.75 55.76 1.18 83.03 4.74 27.29 3.56 55.16 6.52 96.09 20.17 40.92 13.05 84.82 28.46 104.98 58.11 29.06 42.71 40.92 105.58 3.56 123.36-5.55 2.77-9.75 4.78-12.92 6.17 14.82-12.72 33.29-45.73-51.74-108.17-11.84-7.32-31.06-12.58-48.13-15.57-.17-.21-.41-.24-.72-.12-11.72-2.01-22.37-2.94-28.84-2.7-.26 1.81-.47 3.26-.63 4.52.31-3.54.86-6.6 1.22-8.08 1.79-6.52 7.11-8.3 5.34-14.23-2.37-5.93-3.55-4.75-14.82-6.52-10.68-1.79-54.57-15.42-71.77-16.61-8.3-.59-25.5-4.75-24.91 5.34.57 10.41-.53 20.26 5.46 30.64-8.62-2.83-111.83-4.69-170.34-35.39-5.93-4.15 6.52-2.96 2.37-8.3 0 0-52.79-13.65-92.52-43.89-5.26-3.95-8.26-7.24-4.9-11.09zM3938.57 1096.03s13.65 5.93 21.95 3.56c18.99-5.93 40.33-21.95 66.43-34.99 31.43-15.42 53.38-27.88 75.32-27.29-5.93-1.18-1.78-2.37-14.83-1.18-19.57 1.78-57.53 21.35-92.51 38.55-42.71 21.95-56.36 21.35-56.36 21.35z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "fil41",
    d: "M3738.11 1199.24c-11.86-14.24-10.08-33.81-2.37-49.82-1.18 16.61 1.18 33.81 2.37 49.82zM3723.87 1200.41c-11.87-14.82-10.09-34.4-2.37-50.41-1.18 16.6 1.18 33.8 2.37 50.41zM3710.81 1198.64c-11.86-14.24-10.08-33.81-2.37-49.82-1.18 16.02 1.18 33.22 2.37 49.82zM3751.16 1199.24c-11.27-14.24-10.09-33.81-2.38-49.82-.59 16.02 1.18 33.81 2.38 49.82z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil40",
    d: "M3827.66 589.52h19.58v41.53h-19.58v-41.53zm0-276.97h19.58v41.51h-19.58v-41.51zm0 92.52h19.58v41.51h-19.58v-41.51zm0 92.52h19.58v41.52h-19.58v-41.52z",
    style: {
      stroke: "#006cb5",
      strokeWidth: 1.53,
      strokeMiterlimit: 22.9256
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5aa76f10e46a7fdc814a0ed0dd10debd.svg";
export { ForwardRef as ReactComponent };